module.exports = __webpack_public_path__ + "static/img/12.766176f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/12.png
// module id = n+kw
// module chunks = 0